import { useSyncExternalStore } from "react";
import {
  hasStoredConsent,
  subscribeConsentChange,
} from "../utils/cookie-consent";

/**
 * Дано ли уже какое-либо решение по cookies. Реактивно обновляется при
 * сохранении/отзыве согласия (в т.ч. из другой вкладки).
 *
 * Назначение: показывать постоянную точку отзыва («Настройки cookie») в футере
 * только ПОСЛЕ первичного согласия. Пока показан баннер первичного согласия,
 * второй точки входа быть не должно — иначе на экране входа visible-дубль.
 */
export function useHasCookieConsent(): boolean {
  return useSyncExternalStore(
    subscribeConsentChange,
    hasStoredConsent,
    () => false,
  );
}
